<template>
	<div>
		<!--弹出框-->
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm" style="height: 100%">
			<el-dialog title="组织机构信息" :visible.sync="dialogVisible" :modal="false" v-dialogDrag :before-close="handleClose" :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
				<el-row>
					<el-col :span="24" class="rowTops">
						<el-form-item type="type" label="上级部门" prop="sjcd">
							<!-- <el-input v-model.trim="ruleForm.sjcd" placeholder="上级部门" @focus="focusval($event)" @blur="blurval1($event)"></el-input> -->
						  <el-cascader ref="cascaderAddr" placeholder="所在部门" v-model="cascaderModel" :options="datatree" :show-all-levels="false" @change="handleChange" :props="{ value: 'id',label: 'name',children: 'children', expandTrigger: 'hover', checkStrictly: true}" filterable style="width: 100%;"></el-cascader>
            </el-form-item>
						<!-- <transition name="el-zoom-in-center">
							<div v-show="khdwshow" class="rowTopa">
								<el-tree :data="datatree" class="paddingtree" :expand-on-click-node="false" :highlight-current='true' :default-expand-all="true" :props="defaultProps" @node-click="handleNodeClick" node-key='id' ref="treeList" :filter-node-method="filterNode" :default-expanded-keys='[treesid]'>
								</el-tree>
							</div>
						</transition> -->
					</el-col>
					<el-col :span="24">
						<el-form-item type="type" label="部门名称" prop="bmname">
							<el-input type="type" placeholder="部门名称" class="from-el-input" v-model.trim="ruleForm.bmname"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item type="type" label="部门所在的行政区划" class="from-el-input-line" prop="xzqh">
							<el-input type="type" placeholder="部门所在的行政区划" class="from-el-input" v-model.trim="ruleForm.xzqh"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item type="type" label="联系方式" prop="lxphone">
							<el-input type="type" placeholder="联系方式" class="from-el-input" v-model.trim="ruleForm.lxphone"></el-input>
						</el-form-item>
					</el-col>

				</el-row>
				<span slot="footer" class="dialog-footer">
                    <el-form-item>
                        <el-button round @click="empty()" type="warning">取消</el-button>
                        <el-button round v-if="state=='xz'" type="primary" @click="deteRmine('ruleForm','xz')">保 存</el-button>
                        <el-button round v-if="state=='bj'" type="primary" @click="deteRmine('ruleForm','bj')">保 存</el-button>
                    </el-form-item>
                </span>
			</el-dialog>
		</el-form>
		<!--弹出框-->
	</div>
</template>

<script>
	import { orgaddselect,orgsave,orgupdate } from "@/api/api";

	export default {
		props: {
			mystate: Array
		},
		data() {
			return {
				dialogVisible: true,
				sjcdid: '', //上级菜单id
				state: '',
				ruleForm: {
					sjcd: '',
					bmname: '',
					xzqh: '',
					lxphone: '',
				},
				rules: {
					sjcd: [
						{ required: true, message: "请输入必填项", trigger: "change" },
					],
					bmname: [
						{ required: true, message: "请输入必填项", trigger: "change" },
					],
					xzqh: [
						{ required: true, message: "请输入必填项", trigger: "change" },
					],
					lxphone: [
						{ required: true, message: "请输入必填项", trigger: "change" },
					],
				},
				leixlist: [
					{ name: '目录', id: 0 },
					{ name: '菜单', id: 1 },
					{ name: '按钮', id: 2 },
				],
				datatree: [],
				defaultProps: { /// tree设置
					children: 'children',
					label: 'name'
				},
				khdwshow: false,
				treesid: '',
				row: null,

        cascaderModel: '',
			};
		},
		created() {
			//初始化数据
		},
		components: {},
    // watch: {
    //   "ruleForm.sjcd": {
    //     handler(newval, oldval) {
    //       this.$refs.treeList.filter(newval);
    //     },
    //   },
    // },
		methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      },
			handleNodeClick(data, e) {
				console.log(data)
				this.sjcdid = data.id;
				this.ruleForm.sjcd = data.name;
			},
      handleChange(value) {
        // console.log(this.$refs["cascaderAddr"].getCheckedNodes()[0].value)
        this.sjcdid = this.$refs["cascaderAddr"].getCheckedNodes()[0].value;
        this.ruleForm.sjcd = this.$refs["cascaderAddr"].getCheckedNodes()[0].label;
        this.$refs.cascaderAddr.dropDownVisible = false;
        // console.log(this.cascaderModel)
      },
			focusval(e) {
				this.khdwshow = true
			},
			blurval1(e) {
				let _this = this
				setTimeout(function() {
					_this.khdwshow = false
				}, 200)
			},
			cancel() {

			},
			deteRmine(formName, type) {
				this.$refs[formName].validate(valid => {
					if(valid) {
						if(type == 'xz') {
							let params = {
								parentId: this.sjcdid,
								name: this.ruleForm.bmname,
								regionCode: this.ruleForm.xzqh,
								telephone: this.ruleForm.lxphone,

							}

							orgsave(params).then((res) => {

								if(res.code === 200) {
									this.$notify({
										title: "提示",
										message: "提交成功",
										type: "success"
									});
									this.dialogVisible = false;
									this.$emit("adddata", {
										dialogVisible: this.dialogVisible
									});
								} else {
									this.$notify({
										title: "提示",
										message: res.message,
										type: "warning"
									});
								}

							})
						} else {
							let params = {
								parentId: this.sjcdid,
								name: this.ruleForm.bmname,
								regionCode: this.ruleForm.xzqh,
								telephone: this.ruleForm.lxphone,
								id:this.row.id
							}

							orgupdate(params).then((res) => {

								if(res.code === 200) {
									this.$notify({
										title: "提示",
										message: "提交成功",
										type: "success"
									});
									this.dialogVisible = false;
									this.$emit("bjadddata", {
										dialogVisible: this.dialogVisible
									});
								} else {
									this.$notify({
										title: "提示",
										message: res.message,
										type: "warning"
									});
								}

							})
						}

					} else {
						this.$notify({
							title: '提示',
							message: '请填写完整后再提交',
							type: 'warning'
						})
						return false
					}
				});
			},
			// focusval(e) {
			// 	this.khdwshow = true
			// },
			// blurval1(e) {
			// 	let _this = this
			// 	setTimeout(function() {
			// 		_this.khdwshow = false
			// 	}, 200)
			// },
			empty() {
				this.dialogVisible = false;
				this.$emit("getcancel", {
					dialogVisible: this.dialogVisible
				});
			},
			optionsChange() {

			},

			handleClose() {
				this.dialogVisible = false;
				this.$emit("getcancel", {
					dialogVisible: this.dialogVisible
				});
			},

      getTreeData(data) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].children.length < 1) {
                // 最后一级没有数据将children变成undefined
                data[i].children = undefined;
            } else {
                // children不为空时继续调用该方法
                this.getTreeData(data[i].children);
            }
        }
        return data;
      },
		},
		mounted() {
			console.log(this.mystate)
			this.state = this.mystate[0];
			this.row = this.mystate[1];
			orgaddselect({}).then((res) => {
				console.log(res)
				if(res.code == 200) {
					// this.datatree = [res.data];
          this.datatree = this.getTreeData(res.data.children);
				} else {
					this.$notify({
						title: "提示",
						message: res.message,
						type: "success",
					});
				}
			})

			if(this.mystate[0] == 'bj') {
				this.sjcdid = this.mystate[1].parentId;
				this.ruleForm.bmname = this.mystate[1].name;
				this.ruleForm.xzqh = this.mystate[1].regionCode;
				this.ruleForm.lxphone = this.mystate[1].telephone;
				let _this = this;
				setTimeout(function() {
					_this.$nextTick(function() {
						// _this.$refs.treeList.setCurrentKey(this.sjcdid)
						// _this.ruleForm.sjcd = this.$refs.treeList.getCurrentNode().name
            this.sjcdid = this.mystate[1].parentId;
            this.cascaderModel = this.mystate[1].parentId;
            this.ruleForm.sjcd = this.mystate[1].parentId;
					})
				}, 200)

			}

		}
	};
</script>

<style scoped="scoped">
	>>>.el-dialog {
		width: 600px;
	}

	>>>.el-dialog__body {
		height: 300px;
		overflow: auto;
	}

	.trees {
		width: 98%;
		float: left;
		max-height: 300px;
		height: 60px;
		line-height: 30px;
		padding-left: 2%;
		margin-top: 5px;
	}

	.rowTops {
		position: relative;
	}

	.rowTopa {
		position: absolute;
		left: 100px;
		top: 37px;
		right: 0px;
		margin: auto;
		max-height: 300px;
		background: #fff;
		border: 1px solid #e3e3e3;
		z-index: 100;
		border-radius: 5px;
		overflow: auto;
		padding-bottom: 10px;
	}
</style>
